// PURPOSE: Show earlier job postings on Screening and the lead card.
// CONTRACT: Bounded posting summaries with Toronto dates and the remaining count.
// DEPENDS: OutreachPostingView, outreach.css classes and existing typography tokens.
// CEILING: Read-only presentation; no requests, ownership lookups or sends.
import type { OutreachPostingView } from './types';
import './outreach.css';

function postingDate(value: string) {
  const date = new Date(value.length === 10 ? `${value}T12:00:00Z` : value);
  return Number.isNaN(date.getTime()) ? 'Unknown date' : new Intl.DateTimeFormat('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric', timeZone: 'America/Toronto',
  }).format(date);
}

export function EarlierPostings({ posting }: { posting?: OutreachPostingView | null }) {
  const earlier = posting?.earlier || [];
  const remaining = (posting?.earlier_postings || 0) - earlier.length;
  if (!earlier.length && remaining <= 0) return null;
  return <section aria-label="Posted before" className="earlier-postings">
    <h3 className="small muted">Posted before</h3>
    {earlier.length > 0 && <ul>{earlier.map(item => <li key={item.id}>
      {item.role_title} · {postingDate(item.posted_on || item.captured_at)} · {item.source}
      {/^https?:\/\//i.test(item.source_url) && <> · <a href={item.source_url} target="_blank" rel="noreferrer">View posting</a></>}
    </li>)}</ul>}
    {remaining > 0 && <p className="small muted">and {remaining} more</p>}
  </section>;
}
